import { Layout, Summary, Returns } from '@/views/performance';

export default {
    path: '/performance',
    component: Layout,
    children: [
        { path: 'summary', component: Summary },
        { path: 'returns', component: Returns },
    ]
};
